import i18next from "../../../i18n";

i18next.addResourceBundle("en", "ThemeTabFilter", {
    filter_by_theme: "Filter by theme :",
});

i18next.addResourceBundle("fr", "ThemeTabFilter", {
    filter_by_theme: "Filter par thème :",
});
